<template>
  <a-dropdown :trigger="['click']" placement="bottomLeft">
    <div :class="$style.dropdown">
      <a-badge>
        <a-avatar shape="square" icon="user" size="large" :class="$style.avatar" />
      </a-badge>
    </div>
    <a-menu slot="overlay">
        <!--
      <a-menu-item>
        <div>
          <strong>{{ $t('topBar.profileMenu.hello') }}, {{ user.name || 'Anonymous' }}</strong>
        </div>
        <div>
          <strong class="mr-1">{{ $t('topBar.profileMenu.billingPlan') }}:</strong> Professional
        </div>
        <div>
          <strong class="mr-1">{{ $t('topBar.profileMenu.role') }}:</strong>
          {{ user.role || '—' }}
        </div>
      </a-menu-item>
      <a-menu-divider />
      $t('topBar.profileMenu.email')
      -->
      <a-menu-item>
        <div>
          <strong class="mr-1">Correo electrónico:</strong>
          {{ user.email || '—' }}
        </div>
        <!--
        <div>
          <strong class="mr-1">{{ $t('topBar.profileMenu.phone') }}:</strong> —
        </div>-->
      </a-menu-item>
      <a-menu-divider />
      <a-menu-item @click="redirectToChangePassword">
        <a href="javascript: void(0);">
          <i class="fe fe-user mr-2"></i>
          Cambiar contraseña
        </a>
      </a-menu-item>
      <a-menu-divider />
      <!--
      {{ $t('topBar.profileMenu.logout') }}
      -->
      <a-menu-item>
        <a href="javascript: void(0);" @click="logout">
          <i class="fe fe-log-out mr-2"></i>
            Cerrar sesión
        </a>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
import { mapState } from 'vuex'
import { db } from '../../../../../services/firebase/index'
export default {
  computed: {
    ...mapState(['user']),
    loading() {
      return this.$store.state.user.loading
    },
  },
  data: function () {
    return {

    }
  },
  created() {
    console.log(this.$store.state.user)
  },
  methods: {
    redirectToChangePassword() {
      this.$router.push({ name: 'changePassword' })
    },
    logout() {
      db.collection('consSession').doc(this.$store.state.user.email).delete()
      this.$cognito.signout()
      this.$store.dispatch('user/LOGOUT_COGNITO')
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
